import React, { Component } from 'react'
import Store from 'app/stores/research/arrayPgt/statistics'
import { observer, Provider } from 'mobx-react'
import statisticsIcon from "app/styles/images/sp/statistics-selected.svg"
import DataHeader from './containers/DataHeader'
import DataTable from './containers/DataTable'
import './Index.scss'

@observer
export default class index extends Component {
  constructor(props) {
    super(props)
    this.store = Store.fromJS()
  }

  componentDidMount() {
    const { exportConnectWebsocket } = this.store
    exportConnectWebsocket()
  }

  componentWillUnmount() {
    const { closeExportWebsocket } = this.store
    closeExportWebsocket()
  }

  render() {
    return (
      <Provider store={this.store}>
        <div className="statistics-page pgd">
          <h2 className="page-title">
            <img alt="" src={statisticsIcon} />统计
          </h2>
          <div className="clearfix wrapper-box-first">
            <DataHeader />
          </div>
          <div>
            <DataTable store={this.store} />
          </div>
        </div>
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/research/arrayPgt/statistics/index.js